import { MDCSelect } from '@material/select'

// CornerBit.BOTTOM = 1 (from @material/menu-surface/constants)
const CORNER_BIT_BOTTOM = 1

export default {
  setup() {
    this.select = new MDCSelect(this.el)

    if (this.el.dataset.forceOpenDown !== undefined) {
      const foundation = this.select.menu.menuSurface.foundation
      const orig = foundation.getoriginCorner.bind(foundation)
      foundation.getoriginCorner = () => orig() & ~CORNER_BIT_BOTTOM
    }
  },
  destroy() {
    this.select?.destroy()
    this.select = null
  },
  mounted() {
    this.setup()
  },
  beforeUpdate() {
    this.destroy()
  },
  updated() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
